import { render, staticRenderFns } from "./cambio-direccion-resumen.vue?vue&type=template&id=55fe2fd7&"
import script from "./cambio-direccion-resumen.vue?vue&type=script&lang=ts&"
export * from "./cambio-direccion-resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports